import React, { useEffect } from 'react'
import './deleted.scss';
import { Link } from 'react-router-dom';

const Deleted = () => {
    useEffect(() => {
        document.title = 'Room Deleted'
    }, [])

    return (
        <div id='deleted' style={{ backgroundImage: `url('images/cbb2.png')`, backgroundSize: 'cover' }}>
            <div id='deleted-cont'>
                <h4>The room you are looking for does not exist. It was likely deleted</h4>

                <Link className='ok-link' to='/'>OK</Link>

            </div>
        </div>
    )
}

export default Deleted
